import { get, merge } from 'lodash';
import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState as requestInitialState,
} from '../../utils/redux';

const request = {
  endpoint: 'join_requests',
  type: 'get',
  slug: [
    {
      type: 'payload.query',
      queryParameter: 'limit',
      selector: 'limit',
    },
    {
      type: 'payload.query',
      queryParameter: 'offset',
      selector: 'offset',
    },
  ],
};

const initialState = {
  ...requestInitialState,
  pagination: {
    offset: 0,
    limit: 10,
  },
};

export const consts = createReqConsts('communities', 'usersJoinRequests');
export const paginatedConsts = createReqConsts(
  'communities',
  'usersPaginatedJoinRequests',
  ['LOAD_NEXT_REQUESTS', 'UPDATE_PAGINATION_PARAMETERS'],
);

export const actions = createActions(consts);
export const paginatedActions = createActions(paginatedConsts);

export const watcher = createReqWatcher(consts, actions, request);
export const paginatedWatcher = createReqWatcher(
  paginatedConsts,
  paginatedActions,
  request,
);

const defaultRequestReducer = createReqReducer(consts);

export default (state = initialState, action) => {
  switch (action.type) {
    case consts.SUCCEED: {
      return Object.assign(
        {},
        state,
        requestInitialState,
        {
          succeed: true,
        },
        { list: action.payload },
      );
    }
    case paginatedConsts.SUCCEED: {
      const prevState = get(state, 'list', []);
      return Object.assign({}, state, requestInitialState, {
        succeed: true,
        list: prevState.concat(action.payload),
      });
    }
    case consts.UPDATE_REQUESTS: {
      const id = action.payload;
      const prevState = get(state, 'list');
      const list = prevState.filter(item => {
        return item.id !== id;
      });
      return {
        ...state,
        list,
      };
    }
    case paginatedConsts.UPDATE_PAGINATION_PARAMETERS: {
      const { offset, limit } = action.payload;
      return merge({}, state, {
        pagination: {
          offset,
          limit,
        },
      });
    }
    default: {
      return defaultRequestReducer(state, action);
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/communities/usersJoinRequests.js